// eslint-disable-next-line import/no-unresolved
import * as CSS from "csstype";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { ResponsiveValue, TLengthStyledSystem } from "styled-system";

export interface GenericListProps {
  content: Array<string | GenericListProps>;
  icon?: IconName;
  indentationLevel?: number;
  iconFontSize?: ResponsiveValue<CSS.Property.FontSize<TLengthStyledSystem>>;
  iconPt?: ResponsiveValue<CSS.Property.PaddingTop<TLengthStyledSystem>>;
  iconMr?: ResponsiveValue<CSS.Property.MarginRight<TLengthStyledSystem>>;
  title?: string;
  p?: ResponsiveValue<CSS.Property.Padding<TLengthStyledSystem>>;
  color?: string;
}

export const SUBLIST_INDENTATION_INCREMENT_AMOUNT = 40;
